import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessDeniedComponent } from './access-denied.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [AccessDeniedComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [AccessDeniedComponent]
})
export class AccessDeniedModule { }
